import { images } from "../shared/Images.js";

function Home() {
  return (
    <>
      <div className="row back-drop"></div>
      <div
        className="row home-banner"
        style={{
          backgroundImage: `url(${images.homeBackground})`,
        }}
      >
        <div className="col-10 col-lg-8 block">
          <div className="content-wrapper text-left">
            <h4 className="section-subtitle vertical-text">
              <strong>WHOLESALE&nbsp;</strong>/&nbsp;DISTRIBUTION
            </h4>
            <div className="content">
              <div className="section-subtitle pb-2 intro-heading">
                Gauweng South Africa
              </div>
              <h1 className="section-title main-heading">Energy Resources</h1>

              <p className="py-2">
                Gauweng SA (Pty) Ltd is a registered 100% black owned and
                operated private company. We specialises in the purchasing of
                petroleum products from wholesalers and/or manufacturers, and
                selling them to petroleum retailers, and the public at a minimum
                quantities as required by the Petroleum Products Act.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
